<template>
 <div class="mycalculator" style="display: block;"><!-- +/- display: block; -->
    <div class="calcBox-fon"></div>
    <div class="calcBox">
      <div class="calcBox-container">

        <div class="tablo">{{total}}</div>
        <div class="clearfix"></div>
        <div class="btn12">
          <div class="btnNumb" @click="addnum('7')">7</div>
          <div class="btnNumb" @click="addnum('8')">8</div>
          <div class="btnNumb" @click="addnum('9')">9</div>
          <div class="btnNumb" @click="addnum('4')">4</div>
          <div class="btnNumb" @click="addnum('5')">5</div>
          <div class="btnNumb" @click="addnum('6')">6</div>
          <div class="btnNumb" @click="addnum('1')">1</div>
          <div class="btnNumb" @click="addnum('2')">2</div>
          <div class="btnNumb" @click="addnum('3')">3</div>
          <div class="btnNumb discharge" @click="clear()">C</div>
          <div class="btnNumb" @click="addnum('0')">0</div>
          <div class="btnNumb" @click="addnum('.')">&#8226;</div>
        </div>
        <div class="clearfix"></div>
        <div class="btn4">
          <div class="btn4nub" @click="addnums(100)">100</div>
          <div class="btn4nub" @click="addnums(200)">200</div>
          <div class="btn4nub" @click="addnums(300)">300</div>
          <div class="btn4nub" @click="addnums(500)">500</div>
        </div>
        <div class="clearfix"></div>
        <div class="btn2">
          <div class="btn2cl clCancel" @click="$parent.$emit('modalClosed')">cancel</div>
          <div class="btn2cl clEnter" @click="finish()">enter</div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  export default{
    name: 'Payment',
    data: ()=>{
      return {
        total: "",
      }
    },
    mounted() {
      this.total = this.$store.state.total;
    },
    methods: {
      addnum(num){
        if(this.total == "0"){
          return this.total = num;
        }
        this.total += num;
      },
      addnums(num){
        this.total = parseFloat(this.total) + num;
      },
      clear(){
        this.total = 0;
      },
      finish(){
        this.$store.state.total = this.total;
        this.$parent.$emit('modalClosed')
      }
    }
  };
 </script>
